// extracted by mini-css-extract-plugin
export default {"permissions":"Permissions_permissions__7jlSd","title":"Permissions_title__MecLU","permission":"Permissions_permission__UP3GA"};